import _range from "lodash/fp/range";
import _omit from "lodash/fp/omit";
import _head from "lodash/fp/head";
import _last from "lodash/fp/last";
import _clamp from "lodash/fp/clamp";
import _isEqual from "lodash/fp/isEqual";
import _isString from "lodash/fp/isString";
import _isArray from "lodash/fp/isArray";
import _values from "lodash/fp/values";
import _toPairs from "lodash/fp/toPairs";
import _find from "lodash/fp/find";
import _includes from "lodash/fp/includes";
import _compose from "lodash/fp/compose";
import _curry from "lodash/fp/curry";
import _flow from "lodash/fp/flow";
/**
 * TODO:
 * - Replace lodash functions with own implementations.
 * - Add polyfills.
 */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
export { _flow as flow, _curry as curry, _compose as compose, _includes as includes, _find as find };
export { _toPairs as toPairs, _values as values, _isArray as isArray, _isString as isString, _isEqual as isEqual, _clamp as clamp, _last as last, _head as head, _omit as omit, _range as range };
export var keys = function keys(obj) {
  return Object.keys(obj);
};

// This only works with an array. Might implement iterator
// approach.
export var map = _curry(function (iteratee, arr) {
  return arr.map(iteratee);
});
export var mapValues = _curry(function (iteratee, obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    var _extends2;
    return _extends({}, acc, (_extends2 = {}, _extends2[key] = iteratee(obj[key]), _extends2));
  }, {});
});
export var mapKeys = _curry(function (iteratee, obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    var _extends3;
    var newKey = iteratee[key];
    return _extends({}, acc, (_extends3 = {}, _extends3[newKey] = obj[key], _extends3));
  });
});
export var reverse = function reverse(arr) {
  return [].concat(arr).reverse();
};
export var findLast = _curry(function (predicate, arr) {
  return _flow(reverse, _find(predicate))(arr);
});
export var reduce = _curry(function (iteratee, acc, arr) {
  return arr.reduce(iteratee, acc);
});
export var filter = _curry(function (predicate, arr) {
  return arr.filter(predicate);
});
export var defaultTo = _curry(function (defaultVal, val) {
  return val || defaultVal;
});
export var concat = _curry(function (first, second) {
  return first.concat(second);
});
export var slice = _curry(function (start, end, arr) {
  return arr.slice(start, end);
});
export var identity = function identity(val) {
  return val;
};
export var some = _curry(function (predicate, arr) {
  return arr.some(predicate);
});

// This will automatically disregard falsy values.
export var pick = _curry(function (picks, obj) {
  return reduce(function (picked, prop) {
    var _extends4;
    return obj[prop] ? _extends({}, picked, (_extends4 = {}, _extends4[prop] = obj[prop], _extends4)) : picked;
  }, {}, picks);
});
export var pickBy = _curry(function (iteratee, obj) {
  return _flow(keys, reduce(function (picked, key) {
    var _extends5;
    return iteratee(obj[key]) ? _extends({}, picked, (_extends5 = {}, _extends5[key] = obj[key], _extends5)) : picked;
  }, {}))(obj);
});
export var toBool = function toBool(val) {
  return !!val;
};

// This is only useful for debugging a pipe set up
// with flow or compose.
export var trace = function trace(val) {
  console.log(trace); // eslint-disable-line
  return val;
};